import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AdminLayout from '../components/layout/AdminLayout';
import ArticleForm from '../components/forms/ArticleForm';
import { createArticle } from '../services/ArticleService';
import { IArticle } from '../types/Article';
import styles from '../styles/FormPages.module.css';
import { useToast } from '../hooks/useToast'; // ✅ Añadido

const DEFAULT_PLACEHOLDER_IMAGE = 'https://via.placeholder.com/1200x800.png?text=Art%C3%ADculo+Paso';

const NewArticle: React.FC = () => {
    const navigate = useNavigate();
    const toast = useToast(); // ✅ Añadido

    const handleSubmit = async (formData: IArticle) => {
        try {
            const { id, ...articleData } = formData; 
            
            let finalImageUrl = articleData.imageUrl;
            if (!finalImageUrl) {
                if (articleData.gallery.length > 0) {
                    finalImageUrl = articleData.gallery[0].url;
                } else {
                    finalImageUrl = DEFAULT_PLACEHOLDER_IMAGE;
                }
            }

            const dataToSubmit = {
                ...articleData,
                imageUrl: finalImageUrl,
                
                gallery: articleData.gallery.map(image => ({
                    url: image.url,
                    caption: image.caption ?? '',
                    description: image.description ?? ''
                })) 
            };

            const newArticle = await createArticle(dataToSubmit as any); 
            
            toast.success('Éxito', 'Artículo creado con éxito'); // ✅ Añadido
            navigate(`/articles/edit/${newArticle.id}`); 
        } catch (error: any) {
            console.error("Error al crear artículo:", error);
            toast.error('Error', `Error al crear el artículo: ${error.message}`); // ✅ Añadido
        }
    };

    return (
        <AdminLayout pageTitle="Crear Nuevo Artículo">
            <div className={styles.formWrapper}>
                <div className={styles.pageHeader}>
                    <h2 className={styles.title}>Crear Nuevo Artículo</h2>
                    <Link to="/articles" className={styles.backButton}>
                        ← Volver a Artículos
                    </Link>
                </div>
                {/* El formulario pasa los datos sin procesar (IArticle) */}
                <ArticleForm onSubmit={handleSubmit} isEditing={false} />
            </div>
        </AdminLayout>
    );
};

export default NewArticle;